import React, { lazy, Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tabs } from '@innovationnorway/cl-react';
import { Spinner } from '@innovationnorway/cl-react';

import {
  DevelopmentProjectDto,
  DevelopmentProjectListItemDto,
  OperationProjectDto,
  PortalProjectDto,
  PortalProjectListItemDto,
} from 'src/api/v2';

import { RegisterInkindDefaultValues } from './RegisterInkindModal';

const ImportInkindForm = lazy(() => import('./ImportInkindForm'));
const RegisterInkindForm = lazy(() => import('./RegisterInkindForm'));

type Props = {
  onClose: () => void;

  defaultValues?: RegisterInkindDefaultValues;

  projects?: (
    | DevelopmentProjectListItemDto
    | PortalProjectListItemDto
    | DevelopmentProjectDto
    | PortalProjectDto
    | OperationProjectDto
  )[];
};

const RegisterInkindFormWrapper: React.FC<Props> = ({ onClose, defaultValues, projects }) => {
  const { t: tSelfEffort } = useTranslation('selfEffort');
  const { t: tCommon } = useTranslation();

  const [tab, setTab] = useState<'multiple' | 'singel'>('multiple');

  return (
    <>
      <Tabs value={tab}>
        <Tabs.List>
          <Tabs.Tab
            value="multiple"
            onClick={() => setTab('multiple')}
            aria-label={tSelfEffort('registerMultiple')}
          >
            {tSelfEffort('registerMultiple')}
          </Tabs.Tab>
          <Tabs.Tab
            value="singel"
            onClick={() => setTab('singel')}
            aria-label={tSelfEffort('registerSingel')}
          >
            {tSelfEffort('registerSingel')}
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>

      <Suspense fallback={<Spinner aria-label={tCommon('loading')} />}>
        {tab === 'multiple' ? (
          <ImportInkindForm onClose={onClose} defaultValues={defaultValues} projects={projects} />
        ) : (
          <RegisterInkindForm onClose={onClose} defaultValues={defaultValues} projects={projects} />
        )}
      </Suspense>
    </>
  );
};

export default RegisterInkindFormWrapper;
